import { bereik, euro, lokaalBedrag, type Dienst } from "../lib/seo-data";

type Props = {
  dienst: Dienst;
  plaatsNaam?: string;
  plaatsSlug?: string;
};

export function Kostentabel({ dienst, plaatsNaam, plaatsSlug }: Props) {
  const omreken = (bedrag: number) => (plaatsSlug ? lokaalBedrag(bedrag, plaatsSlug) : bedrag);
  const titel = plaatsNaam
    ? `${dienst.naam} kosten in ${plaatsNaam}`
    : `${dienst.naam} kosten`;

  return (
    <section className="mt-10">
      <h2 className="text-2xl font-bold">{titel}</h2>
      <p className="mt-3 text-muted-foreground">
        Onderstaande bedragen zijn inclusief btw en gebaseerd op offertes van erkende elektriciens
        {plaatsNaam ? ` in ${plaatsNaam} en omgeving` : " in heel Nederland"}. Reken op een totaal
        van{" "}
        <strong className="text-foreground">
          {bereik(omreken(dienst.van), omreken(dienst.tot))}
        </strong>
        , met {euro(omreken(dienst.gemiddeld))} als meest voorkomende prijs.
      </p>

      <div className="mt-5 grid gap-3 sm:grid-cols-3">
        <div className="rounded-lg border border-border bg-card p-4">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            Gemiddelde prijs
          </p>
          <p className="mt-1 text-xl font-bold">{euro(omreken(dienst.gemiddeld))}</p>
        </div>
        <div className="rounded-lg border border-border bg-card p-4">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            Uurtarief elektricien
          </p>
          <p className="mt-1 text-xl font-bold">{dienst.uurtarief}</p>
        </div>
        <div className="rounded-lg border border-border bg-card p-4">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            Tijd voor de klus
          </p>
          <p className="mt-1 text-xl font-bold">{dienst.doorlooptijd}</p>
        </div>
      </div>

      <div className="mt-5 max-w-full overflow-x-auto rounded-lg border border-border">
        <table className="w-full min-w-[520px] border-collapse text-sm">
          <caption className="sr-only">
            Kostenoverzicht {dienst.naam.toLowerCase()}
            {plaatsNaam ? ` in ${plaatsNaam}` : ""}
          </caption>
          <thead className="bg-secondary text-left">
            <tr>
              <th scope="col" className="px-4 py-3 font-semibold">
                Onderdeel
              </th>
              <th scope="col" className="px-4 py-3 font-semibold">
                Prijs
              </th>
              <th scope="col" className="px-4 py-3 font-semibold">
                Toelichting
              </th>
            </tr>
          </thead>
          <tbody>
            {dienst.kosten.map((k) => (
              <tr key={k.post} className="border-t border-border bg-card">
                <th scope="row" className="px-4 py-3 text-left font-medium">
                  {k.post}
                </th>
                <td className="whitespace-nowrap px-4 py-3 font-semibold">
                  {bereik(omreken(k.van), omreken(k.tot))}
                </td>
                <td className="px-4 py-3 text-muted-foreground">{k.detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="mt-3 text-xs text-muted-foreground">
        Richtprijzen, bijgewerkt in 2026. De exacte prijs hangt af van je installatie, de
        bereikbaarheid en de materialen die je kiest. Vergelijk daarom gratis en vrijblijvend
        meerdere offertes van betrouwbare bedrijven uit jouw regio.
      </p>
    </section>
  );
}
